import { SEARCH } from '../config'
import { filter } from '../utils/object'

export const JOB = 'job'
export const COMPANY = 'company'

export const SearchTypes = {
  [JOB]: { id: JOB, ...SEARCH.types.job },
  [COMPANY]: { id: COMPANY, ...SEARCH.types.company }
}

export const SearchTypeLabel = {
  [JOB]: 'Job suchen',
  [COMPANY]: 'Firma suchen'
}

export const EnabledSearchTypes = filter(SearchTypes, ({ enabled = true }) => enabled)

const enabledSearchTypesCount = Object.keys(EnabledSearchTypes).length
export const hasSearchTypes = enabledSearchTypesCount > 0
export const hasMultipleSearchTypes = enabledSearchTypesCount > 1

export const isJob = type => type === JOB
export const isCompany = type => type === COMPANY

export const DISTANCES = SEARCH.distance.values
export const DEFAULT_DISTANCE = SEARCH.distance.default
export const DEFAULT_SEARCH_LOCATION = SEARCH.defaultLocation

// Sort order
export const SORT_ORDER_AGE = 'age'
export const SORT_ORDER_DISTANCE = 'distance'
export const SORT_ORDER_RELEVANCE = 'relevance'
export const SORT_ORDERS = [SORT_ORDER_AGE, SORT_ORDER_DISTANCE, SORT_ORDER_RELEVANCE]

export const SEARCH_FORM_SETTINGS = {
  [JOB]: {
    namePlaceholder: 'Jobtitel, Stichwort',
    locationPlaceholder: 'Ort, PLZ, Home Office',
    searchAutocompleteType: 'word'
  },
  [COMPANY]: {
    namePlaceholder: 'Firma',
    locationPlaceholder: 'Ort, PLZ',
    searchAutocompleteType: 'company'
  }
}

export const OCCUPATION_FILTER_ID = 'Taetigkeitsbereich'

export const DEFAULT_FILTER_CATEGORY = {
  [JOB]: OCCUPATION_FILTER_ID,
  [COMPANY]: OCCUPATION_FILTER_ID
}

export const CURRENT_LOCATION_SUGGESTION = 'Aktuellen Standort verwenden'
export const CURRENT_LOCATION_PENDING = 'Wir ermitteln Ihren Standort'

export const OPENING_TYPE = {
  CLICK: 'click',
  AUTO: 'auto'
}
